import {PlayerBase} from "../../player/player.base";
import {ChangeDetectionStrategy, Component, Injector} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import { Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError} from "rxjs/operators";
import {Log} from "../../services/Log";


@Component({
  selector: 'app-label',
  template: '<div #component (click)="onClick($event)"></div>',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabelComponent extends PlayerBase {
  genericElm: GenericElm;
  textFn;

  constructor(protected  injector: Injector) {
    super(injector);
  }


  onTextChange() {
    console.log("onTextChange");
    if (this.editMode) {
      const delta = this.genericElm.labelAnchor.clientHeight - this.actualHeight;
      if (delta>0) {
        this.data.Layout[0].$.height = Number(this.data.Layout[0].$.height) + delta;
        this.loadPosAndSize();
        this.playerService.studioChannel$.next({event: "size", playerId: this.playerObject.$.id, width: this.actualWidth, height:this.actualHeight});
      }
      console.log('onTextChange: ' + this.genericElm.labelAnchor.innerText);
      this.playerService.studioChannel$.next({event: "input", playerId: this.playerObject.$.id, text: this.genericElm.labelAnchor.innerText});
    }
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        if (this.data==null) {
          Log.debug();
        }

        self = playerBase;

        if (this.component != null) {
          this.component.nativeElement.classList.add("scene-label");  // used by studio
        }
        if (this.genericElm == null) {
          this.genericElm = new GenericElm(this.component);
        }

        const font = this.data.Label[0].Font[0].$;
        this.genericElm.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }),
      switchMap( a  => {
        if (this.data==null) {
          Log.debug();
        }

        const label = String(this.data.Label[0].Text[0]);
        const animate = (this.editMode==false && (this.animation?.animIn?.textTyping));
        this.setText(label, animate);
        return of('a');
      }),
      catchError(err => this.logError(err)),
      switchMap( a => of(self) ),
      takeUntil(this.finish$)
    )
  }

  setText(label, animate = false) {
    const editable = this.editMode;
    this.genericElm.setText(label, animate, editable);
    if (editable && this.textFn == null) {
      this.genericElm.labelAnchor.classList.add("editable-label");
      this.textFn = () => { this.onTextChange()  };
      this.genericElm.labelAnchor.addEventListener('input', this.textFn);
    }
  }


  onCommand(command, param): Observable<any> {
    let value;
    const cmd = command.$.command;
    switch (cmd) {

      case 'nextPage': // ??? temp test only
        this.setText(param);
        break;

      case 'setParam':
        this.setText(param);
        break;
      case "addParam":
        value = Number(this.genericElm.label) + Number(param);
        this.setText(value);
        break;
      case "decParam":
        value = Number(this.genericElm.label) - Number(param);
        this.setText(value);
        break;
    }
    return of('onCmd'); //???
  }

  destroy(): void {
    if (this.genericElm != null) {
      if (this.textFn!=null) {
        this.genericElm.labelAnchor.removeEventListener('input', this.textFn);
        this.textFn = null;
      }
      this.genericElm.destroy();
      this.genericElm = null;
    }
    super.destroy();
  }
}
